const companyTypes = [
  {
    id: 'limitedCompany',
    label: 'Limited Company',
    value: '0',
  },
  {
    id: 'soleTrader',
    label: 'Sole Trader/Partnership',
    value: '1',
  },
  {
    id: 'government',
    label: 'Government/Local Authority/Charity',
    value: '3',
  },
  {
    id: 'limitedLiabilityPartnership',
    label: 'Limited Liability Partnership',
    value: '5',
  },
  {
    id: 'publicLimitedCompany',
    label: 'Public Limited Company',
    value: '6',
  },
];

export default companyTypes;
